"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _DialogButtonCancel = _interopRequireDefault(require("../DialogButtonCancel"));

var styles = function styles(theme) {
  return {
    root: {},
    content: theme.mixins.gutters({
      minWidth: theme.spacing(40)
    })
  };
};
/**
 * Jednoduchy dialog bez moznosti potvrzeni ...
 */


var _ref4 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

var DialogSimple = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      classes = _ref.classes,
      fullScreen = _ref.fullScreen,
      onClose = _ref.onClose,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "fullScreen", "onClose", "open", "title"]);

  var handleRequestClose = _react.default.useCallback(function () {
    if (onClose) onClose();
  }, [onClose]);

  var _ref2 = /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    onClick: handleRequestClose,
    "aria-label": "Close"
  }, _ref4);

  var fullScreenTitleBar = function fullScreenTitleBar() {
    return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
      style: {
        position: 'relative',
        marginBottom: 24
      }
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1",
      color: "inherit",
      style: {
        flex: 1
      }
    }, title)));
  };

  var _ref3 = /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title);

  var titleBar = function titleBar() {
    return _ref3;
  };

  var titleComponent = fullScreen ? fullScreenTitleBar() : titleBar();
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({
    ref: ref,
    open: open,
    onClose: handleRequestClose,
    fullScreen: fullScreen
  }, rest), titleComponent, /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    className: classes.content
  }, children), !fullScreen && /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DialogButtonCancel.default, {
    onClick: handleRequestClose
  })));
});

process.env.NODE_ENV !== "production" ? DialogSimple.propTypes = {
  /** Obsah dialogu => po rozkliknuti se otevre obsah */
  children: _propTypes.default.node,

  /** Funkce pro uzavreni dialogu */
  onClose: _propTypes.default.func,

  /** Boolean pro otevreni dialogu => state = { open: false/true} */
  open: _propTypes.default.bool,

  /** Nazev dialogu */
  title: _propTypes.default.node.isRequired
} : void 0;
DialogSimple.displayName = 'DialogSimple';

var _default = (0, _styles.withStyles)(styles, {
  name: 'SxDialogSimple'
})(DialogSimple);

exports.default = _default;